import { Component, HostBinding } from '@angular/core';
import { PageContainer } from '../../cockpit/_shared/page-container/page-container';
import { HeaderService } from '../../cockpit/_shared/header/header.service';
import { TranslateService, UtilityService } from '@mono-repo/util';
import { UserService } from '../../cockpit/user/user.service';
import { forkJoin } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { ConfigService } from '../../config.service';

@Component({
  selector: 'app-terms-of-use-and-privacy-policy-agreement',
  templateUrl: './terms-of-use-and-privacy-policy-agreement.component.html',
})
export class TermsOfUseAndPrivacyPolicyAgreementComponent extends PageContainer {
  @HostBinding('class') class = 'dt-login dt-c-interactive-dialog dt-c-app-terms-of-use-and-privacy-policy-agreement';

  public showTermsOfUse = false;
  public showPrivacyPolicy = false;
  public whatChanged: string;

  constructor(
    headerService: HeaderService,
    translateService: TranslateService,
    private userService: UserService,
    private utilityService: UtilityService,
    private readonly configService: ConfigService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
  ) {
    super(headerService, translateService);
    this.setTranslateModule('agreements');
    // Clients without terms of use only refer to their privacy policy, so the terms of use are left out completely
    const hideTermsOfUse = this.configService.getConfig().hideTermsOfUseLink === true;
    this.activatedRoute.queryParams.subscribe((params) => {
      this.showTermsOfUse = !hideTermsOfUse && params['showTermsOfUse'] === 'true';
      this.showPrivacyPolicy = hideTermsOfUse || params['showPrivacyPolicy'] === 'true';
      if (this.showTermsOfUse && this.showPrivacyPolicy) {
        this.whatChanged = this.translateService.translate('PRIVACY_POLICY_AND_TERMS_OF_USE');
      } else if (this.showTermsOfUse) {
        this.whatChanged = this.translateService.translate('TERMS_OF_USE');
      } else {
        this.whatChanged = this.translateService.translate('PRIVACY_POLICY');
      }
    });
  }

  public openPrivacyPolicy(): void {
    this.utilityService.openExternalLink(this.configService.getConfig().privacyPolicyUrl);
  }

  public openTermsOfUse(): void {
    this.utilityService.openExternalLink(this.configService.getConfig().termsOfUseUrl);
  }

  public accept(): void {
    forkJoin({
      privacyPilicy: this.userService.setPrivacyPolicyAgreement(),
      termsOfUse: this.userService.setTermsOfUseAgreement(),
    }).subscribe(
      () => this.router.navigateByUrl('/cockpit'),
      (error) => console.error(error),
    );
  }
}
